// extracted by mini-css-extract-plugin
module.exports = {"arrow":"mJ","dropMenu":"mK","dropMenuInner":"mL","itemborder":"mM","dropDownCurrent":"mN","menuItem":"mO","langContainer":"mP","current":"mQ","outlink":"mR"};